















import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';

@Component
export default class ReferCompany extends Vue {
  @Prop() promoteReferral;
  private referral = vxm.referrals.getReferralSuccess;
  get referralBannerURL() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.jobs.BrandingInfo.companycode}/CANDIDATEPORTAL/ic_referbanner.png`;
  }
  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE');
  }
  get companyName() {
    return this.$t('myreferrals.refercompany', {
      companyName: vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME'),
    });
  }
  goToInvitePage() {
    vxm.referrals.setRefferedJob('');
    this.$cookies.remove('referralSuccess');
    this.$cookies.remove('frictionLess');
    this.$router.push({
      name: 'Invite',
    });
  }

  get appReferralContent() {
    return this.referral && this.referral.appShareInfo;
  }
}
